import React, { Component } from 'react';
import { Button, Col, CustomInput, Input, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { postAPI, getAPI } from '../../Base/API';
import { StyledCard, BlankCard, ActiveInactiveStatusBadge, ActiveInactiveStatusCombo } from '../../Base/Common/CommonUIComponents';
import { CustomTable } from '../../Base/Common/CustomTable';
import { handleNotification } from "../../Base/Common/Notification";
import { FormattedMessage, injectIntl } from 'react-intl';
import { getCodeGenerationTypes, getHotelGroupModules } from '../../Base/Common/ReferenceDataFunctions';
import CustomSelect from '../../Base/Common/CustomSelect';

class AdminHotelGroupList extends Component {
    static displayName = AdminHotelGroupList.name;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.form = React.createRef();
        this.state = {
            block: true,
            hoteList: [],
            currentPage: 0,
            PageSize: 10,
            selectedHotel: {
                active: false,
                modules: []
            },
            hotelGroupOptions: []
        }
    }

    componentDidMount() {
        this.getHotelGroups();
    }

    save(e) {
        e.preventDefault();

        if (this.form.current.reportValidity()) {
            this.setState({ block: true });

            let req = {
                "request": {
                    "name": this.state.selectedHotel.name,
                    "hotelGroupId": this.state.selectedHotel.hotelGroupId,
                    "modules": this.state.selectedHotel.modules,
                    "active": this.state.selectedHotel.active,
                    "codeGenerationType": this.state.selectedHotel.codeGenerationType
                }
            }

            postAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="AdminHotelGroupList.HotelGroupUpdated" />, <FormattedMessage id="AdminHotelGroupList.Success" />);
                    this.setState({ modal: false }, this.getHotelGroups);
                }
                else {
                    this.setState({ error: errorMessage, block: false });
                }
            }, '/api/Voucher/Hotel/v1/HotelGroup', req);
        }
    }

    getHotelGroups = (e) => {
        if (e) e.preventDefault();

        const { hotelGroupId, modules, codeGenerationType, status } = this.state;
        
        var params = '?';
        if (hotelGroupId) params += `hotelGroupId=${hotelGroupId}&`;
        if (modules?.length > 0) modules.forEach(m => params += `modules=${m}&`);
        if (codeGenerationType) params += `codeGenerationType=${codeGenerationType}&`;
        if (status !== null && status !== undefined) params += `status=${status}`;

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                const hotelGroupOptions = [...this.state.hotelGroupOptions];

                data.response.forEach(resp => {
                    if (resp.modules == null) {
                        resp.modules = [];
                    }

                    if (!this.state.hotelGroupOptions || this.state.hotelGroupOptions.length === 0) {
                        hotelGroupOptions.push({ value: resp.hotelGroupId, label: resp.name });
                    }
                });

                this.setState({ hoteList: data.response, hotelGroupOptions, block: false });
            }
            else {
                this.setState({ error: errorMessage, block: false });
            }
        }, '/api/Voucher/Hotel/v1/HotelGroup' + params);
    }

    toggleModal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    updateForm(f, evt) {

        let name = evt.target.name;
        let value = evt.target.value;

        this.setState(prevState => ({
            ...prevState,
            [f]: {
                ...prevState[f],
                [name]: value

            },
        }));
    }

    handleModules = (combo, evt) => {
        if (evt) {
            const { selectedHotel } = this.state;
            selectedHotel.modules = combo !== null ? combo.map(mdl => mdl.value) : [];
            this.setState({ selectedHotel });
        }
    }

    handleActive = (evt) => {
        if (evt && evt.target) {
            const { selectedHotel } = this.state;
            const { checked } = evt.target;
            selectedHotel.active = checked;

            this.setState({ selectedHotel });
        }
    }

    handleCodeGenerationType = (combo, evt) => {
        if (evt) {
            const { selectedHotel } = this.state;
            selectedHotel.codeGenerationType = combo && combo.value;
            this.setState({ selectedHotel });
        }
    }

    handleSelect = (name, combo) => {
        const value = combo ? Array.isArray(combo) ? combo.map(el => el.value) : combo.value : null

        this.setState({
            [name]: value
        })
    }

 
    render() {
        const columns = [
            {
                dataField: 'hotelGroupId',
                text: <FormattedMessage id="AdminHotelGroupList.HotelId" />,
                sort: true
            },
            {
                dataField: 'name',
                text: <FormattedMessage id="AdminHotelGroupList.GroupName" />,
                sort: true
            },
            {
                dataField: 'active',
                text: <FormattedMessage id="generic.status" />,
                sort: true,
                formatter: cell => <ActiveInactiveStatusBadge status={cell} />
            },
            {
                dataField: 'modules',
                text: <FormattedMessage id="AdminHotelGroupList.Modules" />,
                formatter: (cell) => cell.map(mdl => {
                    const module = getHotelGroupModules(this.props.intl).find(lm => lm.value === mdl);
                    return module ? module.label : ''
                }).join(', ')
            },
            {
                dataField: 'codeGenerationType',
                text: <FormattedMessage id="AdminHotelGroupList.VoucherCode" />,
                formatter: (cell) => {
                    const codeGenerationType = getCodeGenerationTypes(this.props.intl).find(cgt => cgt.value === cell);
                    return codeGenerationType ? codeGenerationType.label : ''
                }
            }
        ]

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,

            onSelect: (row, isSelect, rowIndex, e) => {
                this.setState({ modal: true, selectedHotel: { ...row } })
            }
        };

        const help = <div> </div>

        return (
            <StyledCard icon={'fa-solid fa-gift'} title={'AdminHotelGroupList.HotelGroup'} help={help} error={this.state.error} block={this.state.block}>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} fade={false} className="modal-xl" >
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage id="AdminHotelGroupList.HotelGroup" />
                    </ModalHeader>
                    <ModalBody className="modal-xl p-0">
                        <BlankCard block={this.state.block}>
                            <form ref={this.form}>
                                <Row className="mb-2">
                                    <Col className="text-right">
                                        <Button className="btn-sm btn-host" onClick={this.save.bind(this)}> <i class="fa-solid fa-floppy-disk" /></Button>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col className="col-2"><FormattedMessage id="AdminHotelGroupList.Name" /></Col>
                                    <Col className="col-4">
                                        <FormattedMessage id="AdminHotelGroupList.HotelGroupName" >
                                        {
                                            placeholder => <Input minLength="3" maxLength="100" placeholder={placeholder} value={this.state.selectedHotel.name} onChange={this.updateForm.bind(this, 'selectedHotel')} name="name" required></Input>
                                        }
                                        </FormattedMessage>
                                    </Col>
                                    <Col className="col-2"><FormattedMessage id="AdminHotelGroupList.GroupId" /></Col>
                                    <Col className="col-4">
                                        <FormattedMessage id="AdminHotelGroupList.GroupId" >
                                            {
                                                placeholder => <Input pattern="^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" name="hotelGroupId" value={this.state.selectedHotel.hotelGroupId} disabled={true} placeholder={placeholder} required></Input>
                                            }
                                        </FormattedMessage>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col className="col-2">
                                        <FormattedMessage id="AdminHotelGroupList.Modules" />
                                    </Col>
                                    <Col className="col-4">
                                        <CustomSelect
                                            options={getHotelGroupModules(this.props.intl)}
                                            onChange={this.handleModules}
                                            value={getHotelGroupModules(this.props.intl).filter(opt => this.state.selectedHotel.modules.some(m => opt.value === m))}
                                            placeholder={<FormattedMessage id="AdminHotelGroupList.Modules" />}
                                            isClearable
                                            isMulti
                                        />
                                    </Col>
                                    <Col className="col-2">
                                        <FormattedMessage id="AdminHotelGroupList.Active" />
                                    </Col>
                                    <Col className="col-4">
                                        <CustomInput type="switch" checked={this.state.selectedHotel.active} name="active" id="active" onChange={this.handleActive} />
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col className="col-2">
                                        <FormattedMessage id="AdminHotelGroupList.VoucherCode" />
                                    </Col>
                                    <Col className="col-4">
                                        <CustomSelect
                                            options={getCodeGenerationTypes(this.props.intl)}
                                            onChange={this.handleCodeGenerationType}
                                            value={getCodeGenerationTypes(this.props.intl).filter(opt => this.state.selectedHotel.codeGenerationType === opt.value)}
                                            placeholder={<FormattedMessage id="AdminHotelGroupList.VoucherCode" />}
                                            required
                                        />
                                    </Col>
                                </Row>
                            </form>
                        </BlankCard>
                    </ModalBody>
                </Modal>

                <Row className="mb-4 align-items-center">
                    <Col>
                        <CustomSelect
                            options={this.state.hotelGroupOptions}
                            isClearable
                            placeholder={<FormattedMessage id="AdminHotelGroupList.HotelGroup" />}
                            onChange={(e) => this.handleSelect('hotelGroupId', e)}
                        />
                    </Col>
                    <Col>
                        <CustomSelect
                            options={getHotelGroupModules(this.props.intl)}
                            isClearable
                            isMulti
                            placeholder={<FormattedMessage id="AdminHotelGroupList.Modules" />}
                            onChange={(e) => this.handleSelect('modules', e)}
                        />
                    </Col>
                    <Col>
                        <ActiveInactiveStatusCombo
                            name='status'
                            isClearable
                            onChangeFunc={(name, combo) => this.handleSelect(name, combo)}
                            placeholder={<FormattedMessage id="generic.status" />}
                        />
                    </Col>
                    <Col>
                        <CustomSelect
                            options={getCodeGenerationTypes(this.props.intl)}
                            isClearable
                            placeholder={<FormattedMessage id="AdminHotelGroupList.VoucherCode" />}
                            onChange={(e) => this.handleSelect('codeGenerationType', e)}
                        />
                    </Col>
                    <Col className="text-right">
                        <Button className="btn-sm btn-host" onClick={this.toggleModal}><i className="fa-solid fa-plus"></i></Button>
                        <Button className="btn-sm btn-host ml-2" onClick={this.getHotelGroups}><i className="fa-solid fa-magnifying-glass"></i></Button>
                    </Col>
                </Row>
                <CustomTable
                    keyField="hotelGroupId"
                    data={this.state.hoteList ? this.state.hoteList : []}
                    columns={columns}
                    shadow={false}
                    exportCSV={false}
                    showTotal={true}
                    remote={false}
                    selectRow={selectRow}
                />
            </StyledCard>


        );
    }
}
export default injectIntl(AdminHotelGroupList);